import React, { useContext } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import {ToolBarContext} from '../../App'

export default function ToastMessage() {
    
  const {snackBar, setSnackBar, snackBarText} = useContext(ToolBarContext)

  const handleClose = () => {
    setSnackBar(false)
  }

  return (
      <Snackbar
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        open={snackBar}
        onClose={handleClose}
        message={snackBarText}
        autoHideDuration={5000} 
      />
  );
}